import SearchInput, { IProps } from './SearchInput';

export type { IProps };
export default SearchInput;
